var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.9998 16.0504C17.487 16.0504 21.1246 12.4574 21.1246 8.02522C21.1246 3.59301 17.487 0 12.9998 0C8.51251 0 4.87488 3.59301 4.87488 8.02522C4.87488 12.4574 8.51251 16.0504 12.9998 16.0504Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9855 24.087C25.9929 23.9728 25.9929 23.8582 25.9855 23.744C25.9534 23.3219 25.8336 22.9097 25.6329 22.5304C24.8431 20.9871 22.6287 20.2879 20.7811 19.8922C19.4628 19.6178 18.1234 19.4414 16.7754 19.3646L15.365 19.259H14.7303H13.9405H12.0505H11.2607H10.626L9.21557 19.3646C7.86758 19.4414 6.5282 19.6178 5.20997 19.8922C3.36231 20.2352 1.14794 20.9475 0.358103 22.5304C0.157418 22.9097 0.0376519 23.3219 0.00549714 23.744C-0.00183238 23.8582 -0.00183238 23.9728 0.00549714 24.087C-0.00127007 24.2012 -0.00127007 24.3157 0.00549714 24.4299C0.0438608 24.8484 0.168383 25.256 0.372208 25.6303C1.16205 27.1737 3.37641 27.8728 5.22407 28.2685C6.54476 28.5301 7.88312 28.7064 9.22968 28.7962L10.6401 28.8885H10.9786H11.2748H14.7444H15.0406H15.3791L16.7896 28.7962C18.1361 28.7064 19.4745 28.5301 20.7952 28.2685C22.6428 27.9124 24.8572 27.2133 25.647 25.6303C25.8414 25.2442 25.9607 24.8288 25.9996 24.4036C26.0014 24.2979 25.9967 24.1922 25.9855 24.087Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7a459891b23a2b95ca11915f7acc4e3a.svg";
export { ForwardRef as ReactComponent };